import _extends from "@babel/runtime/helpers/esm/extends";
import { getTabOrders, getNextTabItem, getFirstFocusDate } from '../utils/NavUtils';
import { LEFT_CALENDAR_PANEL, CALENDAR_PANEL, CALENDAR_POSITION } from '../utils/constants';
var keyboardControlAreaReducerGen = function keyboardControlAreaReducerGen(args) {
  var activeStartDateStore = args.activeStartDateStore,
    viewStore = args.viewStore,
    disabled = args.disabled,
    isInDoubleCalendar = args.isInDoubleCalendar,
    leftPanelRefList = args.leftPanelRefList,
    dateValidator = args.dateValidator,
    dateCalculator = args.dateCalculator,
    inputRefList = args.inputRefList,
    momentUtils = args.momentUtils;
  return function (state, action) {
    var activeStartDateLeft = activeStartDateStore.activeStartDateLeft;
    var _action$payload = action.payload,
      payload = _action$payload === void 0 ? {} : _action$payload;
    var _payload$calendarPosi = payload.calendarPosition,
      calendarPosition = _payload$calendarPosi === void 0 ? CALENDAR_POSITION.LEFT : _payload$calendarPosi,
      event = payload.event,
      value = payload.value,
      isKeyboard = payload.isKeyboard;
    var view = viewStore.view;
    var tabOrders = getTabOrders(view, calendarPosition, disabled, isInDoubleCalendar, leftPanelRefList);
    var getStartDate = momentUtils.getStartDate;
    switch (action.type) {
      case 'setNav':
        return _extends({}, state, payload);
      case 'clearNav':
        return {
          keyboardControlArea: null,
          keyboardNavDate: null,
          keyboardNavDateRight: null
        };
      case 'setNavWhenPressTab':
        var currentKeyboardControlArea = state.keyboardControlArea;
        var nextKeyboardControlArea = getNextTabItem(tabOrders, currentKeyboardControlArea, event);
        var keyboardNavDate = null;
        if (nextKeyboardControlArea.includes && nextKeyboardControlArea.includes(CALENDAR_PANEL)) {
          keyboardNavDate = getFirstFocusDate(value, view, activeStartDateLeft);
        }
        return {
          keyboardControlArea: nextKeyboardControlArea,
          keyboardNavDate: keyboardNavDate,
          keyboardNavDateRight: null
        };
      case 'setNavWhenDrillDown':
        var NextKeyboardNavDate = null;
        var NextKeyboardControlArea = null;
        NextKeyboardNavDate = getFirstFocusDate(value, view, activeStartDateLeft);
        NextKeyboardControlArea = isInDoubleCalendar ? LEFT_CALENDAR_PANEL : CALENDAR_PANEL;
        return {
          keyboardControlArea: NextKeyboardControlArea,
          keyboardNavDate: NextKeyboardNavDate,
          keyboardNavDateRight: null
        };
      case 'setNavWhenDrillUp':
        var activeStartDate = getStartDate(activeStartDateLeft, view);
        var nextKeyboardNavDate = null;
        var now = new Date();
        var range = dateCalculator.calculateStartAndEndDateOfView(view, activeStartDate);
        if (value instanceof Array) {
          value = value[0];
        }
        if (range && range[0] && range[1]) {
          if (value && dateValidator.isDayInRange(value, range[0], range[1])) {
            nextKeyboardNavDate = value;
          } else if (dateValidator.isDayInRange(now, range[0], range[1])) {
            nextKeyboardNavDate = now;
          } else {
            nextKeyboardNavDate = activeStartDate;
          }
        }
        return {
          keyboardControlArea: isInDoubleCalendar ? LEFT_CALENDAR_PANEL : CALENDAR_PANEL,
          keyboardNavDate: nextKeyboardNavDate,
          keyboardNavDateRight: null
        };
      case 'setInputFocus':
        setTimeout(function () {
          // @ts-ignore
          inputRefList[1].current.focus();
          inputRefList[1].current.setSelectionRange(9999, 9999);
          isKeyboard && inputRefList[2].current.classList.add('keyboard-focus');
        }, 200);
        return _extends({}, state);
      default:
        return;
    }
  };
};
export default keyboardControlAreaReducerGen;